module.exports = __webpack_public_path__ + "img/a92d96a.png";